<template>
  <ul class="navigation-sp-footer">
    <li class="navigation-sp-item">
      <a class="navigation-sp-item-inner" href="/">企業サイト トップ</a>
    </li>

    <footer-sp-navigation-about></footer-sp-navigation-about>

    <li class="navigation-sp-item">
      <a class="navigation-sp-item-inner" href="/business/">事業案内</a>
    </li>
    <li class="navigation-sp-item">
      <a class="navigation-sp-item-inner" href="/csr/">CSR</a>
    </li>
    <li class="navigation-sp-item">
      <a class="navigation-sp-item-inner" href="/news/">ニュース</a>
    </li>

    <footer-sp-navigation-ir></footer-sp-navigation-ir>

    <footer-sp-navigation-travel></footer-sp-navigation-travel>

    <li class="navigation-sp-item">
      <a
        class="navigation-sp-item-inner"
        href="https://career.tabikobo.com/guideline/"
        >採用情報</a
      >
    </li>

    <li class="navigation-sp-item">
      <a
        class="navigation-sp-item-inner"
        href="https://www.tabikobo.com/policy/"
        >プライバシーポリシー</a
      >
    </li>
  </ul>
</template>

<script>
import FooterSpNavigationAbout from "@/components/molecules/FooterSpNavigationAbout";
import FooterSpNavigationIr from "@/components/molecules/FooterSpNavigationIr";
import FooterSpNavigationTravel from "@/components/molecules/FooterSpNavigationTravel";

export default {
  components: {
    FooterSpNavigationAbout,
    FooterSpNavigationIr,
    FooterSpNavigationTravel,
  },
};
</script>
